import { render } from "./NotificationSettingsStockwatchGrid.vue?vue&type=template&id=22fc454d"
import script from "./NotificationSettingsStockwatchGrid.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsStockwatchGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__